import find from 'lodash.find';

import { FOTO_FLAT, SINGLE_PHOTO, PHOTO_DVD, PHOTO_BOOK, PAYPAL } from './variables';

/****************************************************************************************

                                        VARIANTS

*****************************************************************************************/

export function getPhotoVariant(variants, name) {
  return find(variants, v => v.name === name);
}

/****************************************************************************************

                                        LINE ITEMS

*****************************************************************************************/

export function getLineItem(lineItems, type) {
  return find(lineItems, li => li.product.type === type);
}

export function getLineItemById(lineItems, id) {
  return find(lineItems, li => li.product.id === id);
}

/****************************************************************************************

                                        PRODUCTS

*****************************************************************************************/

export function getProduct(products, type) {
  // In the old system, a distinction was made between single photos belonging to a
  // certain category and photos that do not. The photos that belonged to a specific
  // category were cheaper than the others. In the new system all single photos have the
  // same price.
  if (type === SINGLE_PHOTO) {
    return find(products, p => p.type === type && !p.mediaCollection);
  }
  return find(products, p => p.type === type);
}

export function getFotoFlat(products) {
  return getProduct(products, FOTO_FLAT);
}

export function getSinglePhoto(products) {
  return getProduct(products, SINGLE_PHOTO);
}

export function getPhotoDvd(products) {
  return getProduct(products, PHOTO_DVD);
}

export function getPhotoBook(products) {
  return getProduct(products, PHOTO_BOOK);
}

export function includesFotoFlat(products) {
  return Boolean(getFotoFlat(products));
}

export function includesSinglePhoto(products) {
  return Boolean(getSinglePhoto(products));
}

export function includesPhotoDvd(products) {
  return Boolean(getPhotoDvd(products));
}

export function includesPhotoBook(products) {
  return Boolean(getPhotoBook(products));
}

/****************************************************************************************

                                        PAYMENT METHODS

*****************************************************************************************/

export function getPaymentMethod(paymentMethods, name) {
  return find(paymentMethods, pm => pm.name === name);
}

export function includesPayPal(paymentMethods) {
  return Boolean(getPaymentMethod(paymentMethods, PAYPAL));
}

/****************************************************************************************

                                        PATH/URL

*****************************************************************************************/

export function pathHasLoginToken(path) {
  if (path) {
    if (path.split('=')[0] === '?login_token') {
      return true;
    }
  }
  return false;
}

export function getLoginTokenFromPath(path) {
  // Some services, for example Facebook, might append another parameter to the URL
  const queryStringParams = path.split('&');
  return queryStringParams[0].split('=')[1];
}

export function getLanguageFromPath(path) {
  const language = path.split('/')[1];
  return language ? language : '';
}

/****************************************************************************************

                                        MEDIA COUNT

*****************************************************************************************/

export function hasMedia(object) {
  if (!object) {
    return false;
  }
  return object.media.mediaInfo.count > 0;
}

export function hasEnoughMedia(mediaCount, fotoFlat, singlePhoto) {
  if (!fotoFlat) {
    return true;
  }
  if (!singlePhoto) {
    return true;
  }

  if (singlePhoto.price.amount !== 0) {
    const minCountNecessary = fotoFlat.price.amount / singlePhoto.price.amount;
    return mediaCount >= minCountNecessary;
  }
}

/****************************************************************************************

                                      Formatted Amount

*****************************************************************************************/

export function getRealAmount(price) {
  return (price.amount / 100).toFixed(2);
}
